import { render, staticRenderFns } from "./FrzEnterChamberQR.vue?vue&type=template&id=0dc49d1c"
import script from "./FrzEnterChamberQR.vue?vue&type=script&lang=js"
export * from "./FrzEnterChamberQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports